<app-custom-table *ngIf="tableData.length" [tableData]="tableData" [columnHeader]="columnHeader"
    [activatedRow]="activatedRow" [filterArray]="filterArray" (rowAction)="openDialog($event)"></app-custom-table>